import React, { useRef } from 'react';
import { string, bool, func } from 'prop-types';
import { nanoid } from 'nanoid';

function Checkbox({ checked, id, label, onChange }) {
  const labelId = useRef(`id-${nanoid()}`);

  return (
    <div className="checkbox">
      <input
        className="checkbox__input"
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-labelledby={labelId.current}
      />
      <label className="checkbox__label" htmlFor={id}>
        <span className="checkbox__label-text" id={labelId.current}>
          {label}
        </span>
        <svg className="checkbox__icon">
          <use xlinkHref="#check-outline" />
        </svg>
      </label>
    </div>
  );
}

Checkbox.propTypes = {
  checked: bool.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  onChange: func.isRequired
};

export default Checkbox;
